module.exports = __webpack_public_path__ + "media/images/check-image-desktop-be46ee8c.png";